(() => {
  if (window.cuumyJapaneseFormsInstalled) return;
  window.cuumyJapaneseFormsInstalled = true;
  let errorCounter = 0;
  const fields = form => [...form.querySelectorAll('input,select,textarea')].filter(el => el.willValidate && !el.disabled);
  const label = field => (field.labels?.[0]?.textContent || '').replace(/[*＊]/g, '').trim();
  const message = field => {
    const v = field.validity;
    const empty = field.type === 'checkbox' ? !field.checked : !field.value.trim();
    if (field.required && empty) {
      if (field.type === 'checkbox') return 'プライバシーポリシーをご確認のうえ、同意のチェックを入れてください。';
      if (field.tagName === 'SELECT') return (label(field) || '項目') + 'を選択してください。';
      return (label(field) || '必須項目') + 'を入力してください。';
    }
    if (v.typeMismatch && field.type === 'email') return '有効なメールアドレスを入力してください（例：name@example.com）。';
    if (v.typeMismatch && field.type === 'url') return '有効なURLを入力してください。';
    if (v.rangeUnderflow || v.rangeOverflow) return '指定された範囲内の数値を入力してください。';
    if (v.badInput || v.stepMismatch) return '正しい数値を入力してください。';
    if (v.tooShort) return '入力した文字数が不足しています。';
    if (v.tooLong) return '入力した文字数が多すぎます。';
    if (v.patternMismatch || !v.valid) return (label(field) || '入力内容') + 'を正しい形式で入力してください。';
    return '';
  };
  const clearError = field => {
    field.removeAttribute('aria-invalid');
    const id = field.dataset.cuumyErrorId;
    if (!id) return;
    document.getElementById(id)?.remove();
    const remaining = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(v => v && v !== id);
    if (remaining.length) field.setAttribute('aria-describedby', remaining.join(' '));
    else field.removeAttribute('aria-describedby');
    delete field.dataset.cuumyErrorId;
  };
  const showError = (field, text) => {
    clearError(field);
    field.setAttribute('aria-invalid', 'true');
    const error = document.createElement('p');
    error.className = 'cuumy-field-error';
    error.id = 'cuumy-field-error-' + (++errorCounter);
    error.textContent = text;
    const target = field.type === 'checkbox' ? field.closest('label') || field : field;
    target.insertAdjacentElement('afterend', error);
    field.dataset.cuumyErrorId = error.id;
    field.setAttribute('aria-describedby', [field.getAttribute('aria-describedby'), error.id].filter(Boolean).join(' '));
  };
  document.addEventListener('submit', event => {
    const form = event.target.closest?.('[data-cuumy-ja-form]');
    if (!form) return;
    const issues = [];
    fields(form).forEach(field => { clearError(field); const text = message(field); if(text){issues.push({field,text});showError(field,text);} });
    let summary = form.querySelector('[data-cuumy-client-errors]');
    if (!issues.length) {if(summary) summary.hidden = true;return;}
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'cuumy-form-errors';
      summary.dataset.cuumyClientErrors = '';
      summary.setAttribute('role', 'alert');
      summary.tabIndex = -1;
      form.prepend(summary);
    }
    summary.replaceChildren();
    const heading = document.createElement('p');
    heading.textContent = '入力内容に不備があります。以下の項目をご確認ください。';
    summary.append(heading);
    const list = document.createElement('ul');
    issues.forEach(({text}) => {const item = document.createElement('li');item.textContent=text;list.append(item);});
    summary.append(list);
    summary.hidden = false;
    issues[0].field.focus();
    issues[0].field.scrollIntoView({block:'center',behavior:'auto'});
  }, true);
  ['input','change'].forEach(type => document.addEventListener(type, event => {
    const field = event.target;
    if (!field.closest?.('[data-cuumy-ja-form]') || !field.matches('input,select,textarea')) return;
    if (field.hasAttribute('aria-invalid') && !message(field)) clearError(field);
    const form = field.closest('form');
    const summary = form?.querySelector('[data-cuumy-client-errors]');
    if(summary) summary.hidden = true;
  }));
})();
